import React from 'react';


const NewsListItem = ({item}) => (
	<div className="news-list-item">
      	<div className="news-list-item-left">
      		<a href={`#/newsdetail/${item.ID}`} target="_blank"><img src={item.Thumbnail} alt="" /></a>
      	</div>
      	<div className="news-list-item-right">
      		<h2><a href={`#/newsdetail/${item.ID}`} target="_blank">{item.Title}</a></h2>
      		<div>{item.Created}</div>
      		<p>{`${item.PlainText.substr(0, 100)}...`}</p>
      	</div>
	</div>
);



const NewsList = ({items}) => {
      return (
      	<div className="block-content news-list">
                  {
                        items.map((n, i) => {
                              return(<NewsListItem key={i} item={n} />);
                        })
                  }
      	</div>
      );
}

export default NewsList;


// WEBPACK FOOTER //
// ./src/components/NewsList.js